const CLOSING_MARKS = '」』”’"\')）]】》>'

/**
 * A toast title never ends with a full stop (design-guideline, Toast copy). Text
 * that is also shown as a full sentence somewhere else (a banner, a form error)
 * keeps its 「。」 in the locale file; wrap it here where it becomes a toast title.
 *
 * Drops one trailing 「。」 or ".", also when it sits before a closing quote.
 * Ellipses ("..." and 「…」), 「！」 and 「？」 are left alone.
 * Use it only on a complete sentence that ends with its full stop; do not wrap
 * text that ends with an interpolated value, or an abbreviation such as "etc.".
 * `scripts/ci/toast-title-copy.test.mjs` treats a title wrapped in this as compliant.
 */
export function toastTitle(text: string): string {
  let end = text.trimEnd().length
  while (end > 0 && CLOSING_MARKS.includes(text[end - 1])) end -= 1
  const last = text[end - 1]
  const isFullStop = last === '。' || (last === '.' && text[end - 2] !== '.')
  return isFullStop ? text.slice(0, end - 1) + text.slice(end) : text
}
